/**
 * ETML
 * @ De: Theo Bensaci
 * @ Date: 16:34 19.04.2023
 * @ Description: permette de gerer les page du jeux pour faire des transi styler 
 */

// import game page
import GameTitle from "../GamePage/GameTitle/GameTitle";
import MainMenu from "../GamePage/MainMenu/MainMenu";
import Credit from "../GamePage/Credit/Credit";
import TestPage from "../GamePage/TestPage/TestPage";
import About from "../GamePage/About/About";
import GameLoading from "../GamePage/GameLoading/GameLoading";
import GameCountDown from "../GamePage/GameCountDown/GameCountDown";
import GameLevelTransiton from "../GamePage/GameLevelTransition/GameLevelTransiton";
import GameSentenceShower from "../GamePage/GameSentenceShower/GameSentenceShower";
import GameFinishScreen from "../GamePage/GameFinishScreen/GameFinishScreen";
import Top10 from "../GamePage/TopTen/Top10";

export default class GamePageManager{
    static instance;

    constructor(container){
        GamePageManager.instance=this;
        this.container=container;
        this.pages={
            "GameTitle":<GameTitle/>,
            "MainMenu":<MainMenu/>,
            "Credit":<Credit/>,
            "TestPage":<TestPage/>,
            "About":<About/>,
            "GameLoading":<GameLoading/>,
            "GameCountDown":<GameCountDown/>,
            "GameLevelTransiton":<GameLevelTransiton/>,
            "GameSentenceShower":<GameSentenceShower/>,
            "GameFinishScreen":<GameFinishScreen/>,
            "Top10":<Top10/>
        }
    }

    /**
     * Change actual game page
     * @param {string or int} gameIndex index de la page a afficher 
     */
    static changePage(gameIndex){
        let i = GamePageManager.instance;
        if(i===undefined)return;
        i.container.changeGamePage(i.pages[gameIndex]);
    }
}
